module.exports = __webpack_public_path__ + "img/radio_on.7ae22a0c.svg";